import type { ToastStore } from '@skeletonlabs/skeleton'
import { type FirebaseApp, initializeApp } from 'firebase/app'

import { handleFetch } from './fetch'
import { getCanonicalActiveProducts } from './product'

export interface Config {
  apiBaseUrl: string
  clientBaseUrl: string
  googleIdentityPlatform?: {
    apiKey: string
    authDomain: string
    signInOptions?: firebaseui.auth.Config['signInOptions']
  }
  postHogId?: string
  clearmlAddress?: string
  clearmlProjectId?: string
  mlflowAddress?: string
  mlflowExperimentName?: string
  airGapped?: boolean
  fakeLogin?: boolean
  workosEnabled?: boolean
  autoApproveRuns?: boolean
  activeProducts?: string[]
  activeProductEntitlements?: string[]
  restrictedModelIds?: string[]
  trustedModelProviders?: string[]
  localLlmModelRoot?: string
  enabledUnlearningBehaviors?: string[]
}

let firebaseApp: FirebaseApp | null = null

export const configureFirebase = (config: Config) => {
  if (firebaseApp) {
    return
  }

  const firebaseConfig = {
    apiKey: config.googleIdentityPlatform?.apiKey ?? 'AIzaSyAipKSfmBB0sY-pWDphYsGYd2ykbhRqGpA',
    authDomain: config.googleIdentityPlatform?.authDomain ?? 'hirundo-mvp-dev.firebaseapp.com',
  }

  firebaseApp = initializeApp(firebaseConfig)
}

let config: Config | null = $state(null)

export const resetConfigCache = () => {
  config = null
}

export const getConfig = async (toastStore?: ToastStore): Promise<Config> => {
  if (config) {
    return config
  }
  const result = await (await handleFetch('/config/config.json', {}, '', toastStore)).json()
  const activeProductEntitlements: string[] = Array.isArray(result.activeProductEntitlements)
    ? result.activeProductEntitlements
    : Array.isArray(result.activeProducts)
      ? result.activeProducts
      : []
  const rawActiveProducts = Array.isArray(result.activeProducts)
    ? result.activeProducts
    : activeProductEntitlements
  const normalizedConfig: Config = {
    ...result,
    activeProductEntitlements,
    activeProducts: getCanonicalActiveProducts(rawActiveProducts),
  }
  config = normalizedConfig
  return normalizedConfig
}
